module.exports = __webpack_public_path__ + "img/mix-berry.38e02a87.jpg";